import { ORDER_ITEM_TYPE } from '@mixtiles/web-backend-shared'
import { filterTileParams } from 'components/PhotoBank/tileUtils'
import { PRODUCT_TYPES } from 'services/ProductTypeState'
import type { TilesStore } from 'stores/tilesStore/TilesStore'
import type { TilesCartItem } from '../../CartItem'
import type {
  CartItemsSyncResult,
  ReactiveCartItemAdapter,
} from '../CartItemAdapter.types'
import { buildTilesCartItemFromTiles } from './buildTilesCartItem'

export function createTilesCartItemAdapter(
  tilesStore: TilesStore
): ReactiveCartItemAdapter<TilesCartItem> {
  return {
    kind: 'reactive',
    productType: PRODUCT_TYPES.CLASSIC,

    getCartItemsFromLoadedProduct(): CartItemsSyncResult<TilesCartItem> {
      if (tilesStore.tiles.length === 0 && !tilesStore.hasLoadedLocalTiles) {
        return { status: 'not-loaded' }
      }
      const item = buildTilesCartItemFromTiles(tilesStore)
      if (item) return { status: 'existing', items: [item] }
      return { status: 'not-existing' }
    },

    forceProductLoad() {
      // Tiles load eagerly when TilesStore is constructed, so the product-sync
      // reaction already sees them — nothing to force here.
    },

    hasBackingData() {
      return tilesStore.tiles.length > 0
    },

    clearBackingData() {
      tilesStore.clearTiles()
    },

    buildPricingPayload(item) {
      return {
        productType: PRODUCT_TYPES.CLASSIC,
        products: item.metadata.pricingProducts,
      }
    },

    buildFulfillmentPayload() {
      const orderTiles = tilesStore.providerTiles.map((tile) => ({
        ...filterTileParams(tile),
        itemType: ORDER_ITEM_TYPE.SINGLE_TILES,
      }))
      return {
        orderTiles,
        orderItems: [
          {
            itemId: `${PRODUCT_TYPES.CLASSIC}-cart-item`,
            itemType: ORDER_ITEM_TYPE.SINGLE_TILES,
            title: 'Tiles',
            orderTiles,
            metadata: { categoryName: 'Single Tiles' },
          },
        ],
      }
    },
  }
}
